const TIME_ZONE = 'America/Santiago';

const priceFormatter = new Intl.NumberFormat('es-CL', {
  style: 'currency',
  currency: 'CLP',
  maximumFractionDigits: 0,
});
const dateTimeFormatter = new Intl.DateTimeFormat('es-CL', {
  dateStyle: 'medium',
  timeStyle: 'short',
  timeZone: TIME_ZONE,
});

export function formatPrice(price: number): string {
  return priceFormatter.format(price);
}

export function formatDateTime(iso: string): string {
  return dateTimeFormatter.format(new Date(iso));
}

export const SPACE_LABELS: Readonly<Record<string, string>> = {
  CHECK_IN: 'Recepción',
  MAIN: 'Bodega principal',
  COLD: 'Cámara de frío',
  BUFFER: 'Bodega externa',
  PACKAGING: 'Área de acondicionamiento',
  QUARANTINE: 'Cuarentena',
  CHECK_OUT: 'Despacho',
};

export const STATUS_LABELS: Readonly<Record<string, string>> = {
  AVAILABLE: 'En stock',
  RESERVED: 'Reservadas',
  CONSUMED: 'Consumidas',
  SOLD: 'Vendidas',
  DISPATCHED: 'Despachadas',
  EXPIRED: 'Vencidas',
  QUARANTINED: 'En cuarentena',
  TRANSFERRED_OUT: 'Enviadas a otra distribuidora',
  LOST: 'Sin rastro (anomalía)',
};

export const ORIGIN_LABELS: Readonly<Record<string, string>> = {
  FARMA_CENTRAL: 'Recibido de Farma Central',
  OWN_PRODUCTION: 'Producido por el Grupo 5',
  OTHER_DISTRIBUTOR: 'Recibido de otra distribuidora',
};

export const ORDER_STATUS_LABELS: Readonly<Record<string, string>> = {
  AWAITING_PAYMENT: 'Esperando pago',
  PAID: 'Pagado',
  DISPATCHED: 'Despachado',
  CANCELLED: 'Cancelado',
  PAYMENT_FAILED: 'Pago fallido',
  EXPIRED: 'Expirado',
};

export const CHANNEL_LABELS: Readonly<Record<string, string>> = {
  FTP: 'sFTP',
  PUBSUB: 'Pub/Sub',
  MESSAGING: 'Mensajería',
};

/** States of the course orders system (already in Spanish). */
export const PURCHASE_ORDER_STATE_LABELS: Readonly<Record<string, string>> = {
  creada: 'Creada',
  aceptada: 'Aceptada',
  rechazada: 'Rechazada',
  anulada: 'Anulada',
  vencida: 'Vencida',
  cumplida: 'Cumplida',
};

export const DECISION_REASON_LABELS: Readonly<Record<string, string>> = {
  IN_STOCK: 'Con stock',
  PRODUCIBLE_IN_TIME: 'Se acondiciona a tiempo',
  ALREADY_ACCEPTED: 'Ya estaba aceptada',
  NOT_A_SELLABLE_KIT: 'No es un kit del catálogo',
  INVALID_QUANTITY: 'Cantidad inválida',
  ALREADY_DUE: 'Ya vencida',
  NOT_ENOUGH_TIME: 'Sin tiempo para acondicionar',
};

const MS_PER_MINUTE = 60_000;
const MINUTES_PER_HOUR = 60;

/** Time left until `iso` as "1 h 05 min" / "12 min", or "vencido". */
export function formatTimeLeft(iso: string, now: Date = new Date()): string {
  const minutes = Math.floor((new Date(iso).getTime() - now.getTime()) / MS_PER_MINUTE);
  if (minutes < 0) return 'vencido';
  const hours = Math.floor(minutes / MINUTES_PER_HOUR);
  const rest = String(minutes % MINUTES_PER_HOUR).padStart(2, '0');
  return hours > 0 ? `${String(hours)} h ${rest} min` : `${String(minutes)} min`;
}

/** Link to the traceability viewer for one lot; `fromQuery` keeps a way back to the search. */
export function lotHref(lotId: string, fromQuery = ''): string {
  const back = fromQuery === '' ? '' : `&q=${encodeURIComponent(fromQuery)}`;
  return `/trazabilidad?lote=${encodeURIComponent(lotId)}${back}`;
}

/** Link to a traceability search (lot id, SKU or email). */
export function searchHref(query: string): string {
  return `/trazabilidad?q=${encodeURIComponent(query)}`;
}
